import { DollarSign } from 'lucide-react';
import { CollectionAdmin } from './_P1Common';

export default function AdminPricing() {
  return (
    <CollectionAdmin
      path="pricing"
      title="Cjenik"
      subtitle="Tarifni paketi za pretplatu"
      icon={DollarSign}
      testid="admin-pricing"
      fields={[
        { key: 'name', label: 'Naziv plana' },
        { key: 'slug', label: 'Slug' },
        { key: 'price_eur', label: 'Cijena (EUR)', type: 'number' },
        { key: 'interval', label: 'Interval (monthly/yearly)' },
        { key: 'features', label: 'Značajke (zarezom odvojene)', type: 'textarea' },
        { key: 'sort', label: 'Redoslijed', type: 'number' },
        { key: 'active', label: 'Aktivan', type: 'checkbox' },
      ]}
    />
  );
}
